import { requisitar } from '@/lib/http';
import type { RelatorioDeSaude } from '@/types/api';

/** Verifica se o processo da API esta vivo. */
export function obterSaudeLive(sinal?: AbortSignal): Promise<RelatorioDeSaude> {
  return requisitar<RelatorioDeSaude>('/health/live', sinal === undefined ? {} : { sinal });
}

/**
 * Verifica as dependencias externas da API.
 *
 * Enquanto a persistencia nao existir, o backend responde Degraded e declara
 * na descricao que nada foi verificado. A verificacao real do SQL Server entra
 * na Fase 2 (T10).
 */
export function obterSaudeReady(sinal?: AbortSignal): Promise<RelatorioDeSaude> {
  return requisitar<RelatorioDeSaude>('/health/ready', sinal === undefined ? {} : { sinal });
}
